(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // document.addEventListener('DOMContentLoaded', function () {
  //   document.addEventListener('click', function (e) {
  //     const moreLink = e.target.closest('#HeaderMenu-more');
  //     if (!moreLink) return;
  //     e.preventDefault();
  //     const drawer = document.querySelector('#Details-menu-drawer-container');
  //     const summary = drawer?.querySelector('summary');
  //     if (drawer && summary && !drawer.hasAttribute('open')) {
  //       summary.click();
  //     }
  //   });
  // });

  // document.addEventListener('DOMContentLoaded', function () {
  //   const moreBtns = document.querySelectorAll('#HeaderMenu-more, #HeaderDrawer-more');
  //   const customDrawer = document.querySelector('.more-menu-drawer');
  //   const overlay = document.querySelector('.more-menu-overlay');
  //   const closeBtn = document.querySelector('.drawer-close');
  //   const defaultDrawer = document.querySelector('#Details-menu-drawer-container');
  //   const summaryBtn = document.querySelector('#Details-menu-drawer-container summary');

  //   if (!moreBtns.length || !customDrawer) return;

  //   moreBtns.forEach((btn) => {
  //     btn.addEventListener('click', function (e) {
  //       e.preventDefault();

  //       if (defaultDrawer) {
  //         defaultDrawer.removeAttribute('open');
  //         defaultDrawer.classList.remove('menu-opening');
  //       }

  //       if (summaryBtn) {
  //         summaryBtn.setAttribute('aria-expanded', 'false');
  //       }


  //       document.body.classList.remove('overflow-hidden');

  //       customDrawer.classList.add('active');
  //       document.body.classList.add('overflow-hidden');
  //     });
  //   });

  //   function closeDrawer() {
  //     customDrawer.classList.remove('active');
  //     document.body.classList.remove('overflow-hidden');
  //   }

  //   overlay?.addEventListener('click', closeDrawer);

  //   closeBtn?.addEventListener('click', closeDrawer);

  //   document.addEventListener('keydown', function (e) {
  //     if (e.key === 'Escape') {
  //       closeDrawer();
  //     }
  //   });
  // });

// document.addEventListener('DOMContentLoaded', function () {
//   const headerDrawer = document.querySelector('header-drawer');
//   const drawer = document.querySelector('#Details-menu-drawer-container');
//   const summary = drawer?.querySelector('summary');

//   const defaultMenu = document.querySelector('.default-menu');
//   const moreMenu = document.querySelector('.more-menu-content');

//   document.addEventListener('click', function (e) {
//     const moreBtn =
//       e.target.closest('#HeaderMenu-more') ||
//       e.target.closest('#HeaderDrawer-more');

//     if (!moreBtn) return;

//     e.preventDefault();

//     if (defaultMenu && moreMenu) {
//       defaultMenu.style.display = 'none';
//       moreMenu.style.display = 'block';
//     }

//     headerDrawer.classList.add('more-active');

//     if (drawer && summary && !drawer.hasAttribute('open')) {
//       summary.click();
//     }
//   });

//   function resetMenu() {
//     headerDrawer.classList.remove('more-active');

//     if (defaultMenu && moreMenu) {
//       defaultMenu.style.display = 'block';
//       moreMenu.style.display = 'none';
//     }
//   }

//   document.addEventListener('click', function (e) {
//     const isClose =
//       e.target.closest('.menu-drawer__close-button') ||
//       e.target.closest('.menu-drawer__overlay') ||
//       (e.target.closest('summary') && drawer?.hasAttribute('open'));

//     if (isClose) {
//       resetMenu();
//     }
//   });

//   document.addEventListener('keydown', function (e) {
//     if (e.key === 'Escape') {
//       resetMenu();
//     }
//   });

//   drawer?.addEventListener('toggle', function () {
//     if (!drawer.hasAttribute('open')) {
//       resetMenu();
//     }
//   });
// });

/* document.addEventListener('DOMContentLoaded', function () {
  const headerDrawer = document.querySelector('header-drawer');
  const drawer = document.querySelector('#Details-menu-drawer-container');
  const summary = drawer?.querySelector('summary');
  const body = document.body;

  document.addEventListener('click', function (e) {
    const moreBtn =
      e.target.closest('#HeaderMenu-more') ||
      e.target.closest('#HeaderDrawer-more');

    if (!moreBtn) return;

    e.preventDefault();

    headerDrawer.classList.add('more-active');
    // body.classList.remove('overflow-hidden-tablet');
    body.classList.add('overflow-hidden-more');
    
    if (drawer && summary && !drawer.hasAttribute('open')) {
      summary.click();
    }
  });
  
  function resetDrawer() {
    headerDrawer.classList.remove('more-active');
    // body.classList.add('overflow-hidden-tablet');
    body.classList.remove('overflow-hidden-more');
  }

  document.addEventListener('click', function (e) {
    const isClose =
      e.target.closest('.menu-drawer__close-button') ||
      e.target.closest('.menu-drawer__overlay') ||
      (e.target.closest('summary') && drawer?.hasAttribute('open'));

    if (isClose) {
      resetDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      resetDrawer();
    }
  });

  drawer?.addEventListener('toggle', function () {
    if (!drawer.hasAttribute('open')) {
      resetDrawer();
    }
  });
}); */

  } catch(e) { console.error(e); }
})();
})();
